import React from 'react';
import Plot from 'react-plotly.js';
import { useLayout, useTraces } from 'modules/meteogram/hooks';
import { ChartCard } from './styledComponents';

type Data = {
  [key: string]: {
    [key: string]: string;
  };
};

type Props = {
  data: Data;
  type: string;
};

const DeterministicChart: React.FC<Props> = ({ data, type }) => {
  const layout = useLayout(data, type);
  const traces = useTraces(data, type);

  if (traces.length) {
    return (
      <ChartCard>
        <Plot
          config={{ displayModeBar: false, responsive: true }}
          data={traces}
          layout={{ ...layout, width: undefined, autosize: true }}
          useResizeHandler
          style={{ width: '100%', height: '100%' }}
        />
      </ChartCard>
    );
  }

  return <></>;
};

export default React.memo(DeterministicChart);
